import { ConfigFn } from '@config/types'

const config = (({ publication, deploymentEnv }) =>
  ({
    onesignalSdkUrl: 'https://cdn.onesignal.com/sdks/OneSignalSDK.js',
    appId: `${
      deploymentEnv === 'prod'
        ? (`${
            publication === 'romandie'
              ? '83880ab2-4a11-4a59-9bb5-045960c1c59c' // Romandie Prod
              : '1b9a4377-47f7-4ca7-8389-decf07e188ce' // Blick Prod
          }` as const)
        : (`${
            publication === 'romandie'
              ? '606977d0-5b5f-464d-86ca-4a87d9df34df' // Romandie Stage
              : '1e7324ed-1130-42d2-beeb-ae272bb9459f' // Blick Stage
          }` as const)
    }` as const,
    playerIdStorageKey: 'oneSignalPlayerId',
  }) as const) satisfies ConfigFn

export default config
